export default __webpack_public_path__ + "static/media/pictogramBeaconMobile64.0f3f1486.svg";